export const translateMetric = (key: string): string => {
  const translations: Record<string, string> = {
    title_length_ok: "Tamanho do Título Adequado",
    keyword_in_title: "Palavra-chave no Título",
    keyword_in_meta: "Palavra-chave na Meta Descrição",
    keyword_in_title_left: "Palavra-chave no Início do Título",
    keyword_in_first_paragraph: "Palavra-chave no Primeiro Parágrafo",
    has_single_h1: "Único H1 na Página",
    keyword_in_h1: "Palavra-chave no H1",
    keyword_in_h2: "Palavra-chave no H2",
    keyword_in_h3: "Palavra-chave no H3",
    clean_url: "URL Limpa",
    keyword_in_url: "Palavra-chave na URL",
    is_https: "Protocolo HTTPS"
  };
  return translations[key] || key;
};

export const getMetricDescription = (key: string): string => {
  const descriptions: Record<string, string> = {
    title_length_ok: "O título tem o comprimento adequado para SEO (entre 50-60 caracteres)",
    keyword_in_title: "A palavra-chave principal está presente no título da página",
    keyword_in_meta: "A palavra-chave principal está presente na meta descrição",
    keyword_in_title_left: "A palavra-chave está posicionada no início do título",
    keyword_in_first_paragraph: "A palavra-chave aparece no primeiro parágrafo do conteúdo",
    has_single_h1: "A página possui apenas um título H1",
    keyword_in_h1: "A palavra-chave está presente no título H1",
    keyword_in_h2: "A palavra-chave está presente em algum subtítulo H2",
    keyword_in_h3: "A palavra-chave está presente em algum subtítulo H3",
    clean_url: "A URL é limpa e amigável para SEO",
    keyword_in_url: "A palavra-chave está presente na URL da página",
    is_https: "O site utiliza protocolo HTTPS para segurança"
  };
  return descriptions[key] || key;
};